import React from "react";
import expiredImg from "../../assets/expiredImg.png"
import expiringImg from "../../assets/expiringImg.png"
import { replaceDefaultBrandName } from "../../utils/brandingUtils";

const TrialModal = ({ daysLeft, onClose }) => {
  const isExpired = daysLeft <= 0;
  const modalBackdrop = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalContent = {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    textAlign: "center",
    maxWidth: "800px",
  
    width: "90%",
    position: "relative",
  };

  const closeButton = {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "20px",
    cursor: "pointer",
  };

  return (
    <div style={modalBackdrop}>
      <div style={modalContent}>
        <span style={closeButton} onClick={onClose}>×</span>
        <img
            src={isExpired ? expiredImg : expiringImg}
            alt="Trial Status"
            className="trial-image"
            style={{ width: "120px", margin: "0 auto", display: "block", marginBottom: "20px" }}
          />
        <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "#00A0D1", marginBottom: "10px" }}>
          {isExpired ? (
            replaceDefaultBrandName("Your SkaleBot Trial Has Expired!")
          ) : (
            <>
              {replaceDefaultBrandName("Your SkaleBot Account Trial Ends In")}{" "}
              <span style={{ color: "#e74c3c", fontWeight: "bold" }}>[{daysLeft}]</span> Days!
            </>
          )}
        </h2>
        <p style={{ fontSize: "15px", color: "#333", marginBottom: "30px" }}>
          {isExpired
            ? "🔒 Your Access To Leads, Automations Is Paused."
            : "Don’t Lose Access To Premium Tools! Upgrade Now To Keep Enjoying The Benefits."}
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button
            style={{
              padding: "10px 25px",
              backgroundColor: "#fff",
              border: "2px solid #055F82",
              borderRadius: "30px",
              color: "#000",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
            }}
            onClick={() => (window.location.href = "/dashboard/subscription")}
          >
            View Plans
          </button>

          <button
            style={{
              padding: "10px 25px",
              backgroundColor: "#055F82",
              border: "none",
              borderRadius: "30px",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.15)",
            }}
            onClick={() => (window.location.href = "/dashboard/subscription")}
          >
            Upgrade
          </button>
        </div>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "50px",
    paddingTop: "20px",
  
    fontSize: "14px",
    color: "#4B5563",
    flexWrap: "wrap",
    gap: "10px",
  }}
>
  {/* Left side: Contact us */}
  <div>
    Not ready yet? No worries!{" "}
    <a
      href="mailto:sales@deskala.in"
      style={{
        color: "#00A0D1",
        textDecoration: "underline",
        fontWeight: "500",
      }}
    >
      Contact us
    </a>
  </div>

  {/* Right side: Stars + trust message */}
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

    <span>Loved by 500+ businesses</span>
    <span style={{ color: "#FFD700", fontSize: "16px" }}>★★★★★</span>
  </div>
</div>


      </div>
    </div>
  );
};
export default TrialModal; 
